import { useState } from 'react';
import {addAdditive} from "../../services/Administrative/additiveService";

export const useAddAdditive = () => {
    const [saving, setSaving] = useState(false);

    const addNewAdditive = async (newAdditiveDTO: any) => {
        setSaving(true);
        try {
            const response:any = await addAdditive(newAdditiveDTO);
            return response.data.additive;

        } catch (error: any) {
            throw error.response.data.message;
        } finally {
            setTimeout(() => setSaving(false), 600);
        }
    };

    return { addNewAdditive, saving };
};